module.exports = __webpack_public_path__ + "static/media/blur_job_category_all.8d189c4a.jpg";